import type {Connection} from '@package/shared'
import {Badge} from '@mantine/core'
import {ConnectionTypeIcon} from '../icons/ConnectionTypeIcon.tsx'

type Props = {
  type: Connection['type']
  withLabel?: boolean
}

export const ConnectionTypeBadge = ({type, withLabel = false}: Props) => {
  const name = {
    'ical-subscription': 'Calendar',
    'github-api': 'GitHub',
    'jira-api': 'Jira',
  }[type]

  return (
    <Badge
      size={'lg'}
      circle={!withLabel}
      pt={withLabel ? undefined : 7}
      variant={'light'}
      title={`Connection type: ${name}`}
      leftSection={withLabel ? <ConnectionTypeIcon type={type} /> : undefined}
    >
      {withLabel ? name : <ConnectionTypeIcon type={type} />}
    </Badge>
  )
}
